import { SIGNUP_FLOW_ROOT } from './signup-flow-root';

/**
 * The web app's fixed legal documents: the terms of use, privacy policy,
 * notice of privacy practices, consumer health data privacy notice, AI notice
 * and TCPA authorization production signup shows. Each is a static page
 * at `/<id>/`. They live here, below every feature, so app-wide chrome
 * such as the site footer can link them without loading the signup feature.
 */
export const LEGAL_DOCUMENT_IDS = [
  'terms-of-use',
  'privacy-policy',
  'notice-of-privacy-practices',
  'consumer-health-data-privacy-notice',
  'ai-notice',
  'tcpa-authorization',
] as const;

export type LegalDocumentId = (typeof LEGAL_DOCUMENT_IDS)[number];

/** Static export uses trailing slashes, so every path ends in one. */
export function legalDocumentPath(id: LegalDocumentId): string {
  return `${SIGNUP_FLOW_ROOT}${id}/`;
}

/** Where every legal link points: the site footer, the signup footer, the consents, the entry params. */
export const SIGNUP_LEGAL_DOCUMENT_PATHS = {
  termsOfUse: legalDocumentPath('terms-of-use'),
  privacyPolicy: legalDocumentPath('privacy-policy'),
  noticeOfPrivacyPractices: legalDocumentPath('notice-of-privacy-practices'),
  consumerHealthDataPrivacyNotice: legalDocumentPath('consumer-health-data-privacy-notice'),
  aiNotice: legalDocumentPath('ai-notice'),
  tcpaAuthorization: legalDocumentPath('tcpa-authorization'),
} as const;
